<template>
    <sy-resize-panel ref="echart" @resize="handleResize" />
</template>

<script>
import echarts from 'echarts';

export default {
    name: 'SyChart',
    props: {
        /**
         * 主题
         */
        theme: {
            type: [String, Object],
            default: () => ({})
        },
        /**
         * echart初始化配置
         */
        initOption: {
            type: Object,
            default: () => ({})
        },
        /**
         * echart图表配置
         */
        dataOption: {
            type: Object,
            required: true
        },
        /**
         * 自动适应尺寸变化
         */
        autoResize: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // echart实例
            echart: null
        };
    },
    watch: {
        /**
         * 监听dataOption并刷新echart
         */
        dataOption: {
            handler() {
                this.echart.setOption(this.dataOption, true);
            },
            deep: true
        }
    },
    /**
     * 组件渲染后初始化echart
     */
    mounted() {
        this.initEChart();
    },
    /**
     * 组件销毁前销毁echart
     */
    beforeDestroy() {
        if (!this.echart) {
            return;
        }

        this.echart.dispose();
        this.echart = null;
    },
    methods: {
        /**
         * 初始化echart
         */
        initEChart() {
            this.echart = echarts.init(this.$refs.echart.$el, this.theme, this.initOption);
            this.echart.setOption(this.dataOption, true);
        },
        /**
         * 处理父容器尺寸变化事件
         */
        handleResize() {
            if (!this.echart) {
                return;
            }

            this.echart.resize();
        }
    }
};
</script>
